import { useEffect, useState } from 'react';
import LessonCard from '../training/LessonCard';
import './styles.css';

export default function EventCard({ event }) {
  const [lessonPlans, setLessonPlans] = useState([]);

  useEffect(() => {
    async function fetchLessonPlans() {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/event-lesson-plans?event_id=${event.id}`,
          {
            credentials: 'include',
          }
        );

        if (!response.ok) throw new Error('Failed to fetch');

        const data = await response.json();
        const plans = data
          .map((item) => item.lesson_plan)
          .filter((plan) => plan?.id && plan?.name);

        setLessonPlans(plans);
      } catch (error) {
        console.error('Failed to load lesson plans for event', error);
        setLessonPlans([]);
      }
    }

    if (event?.id) fetchLessonPlans();
  }, [event?.id]);

  return (
    <div className="event-card">
      <h2 className="event-title">{event.name}</h2>
      {event.description && <p className="event-description">{event.description}</p>}

      <div className="lesson-grid">
        {lessonPlans.length > 0 ? (
          lessonPlans.slice(0, 4).map((lp) => (
            <LessonCard key={lp.id} lesson={lp} />
          ))
        ) : (
          <p className="lesson-empty">No lesson plans available.</p>
        )}
      </div>
    </div>
  );
}
